// src/redux/store.ts

import { configureStore } from '@reduxjs/toolkit';
import userProfileReducer from './slices/userProfileSlice';
import gamesReducer from './slices/gamesSlice'; // Importa o reducer do games
import tournamentPlayersReducer from './slices/tournamentPlayersSlice'; // Novo reducer
import counterReducer from './slices/counterSlice';
import clubsReducer from './slices/clubsSlice';
import padelMatchReducer from './slices/padelMatchSlice';
import { padelMatchPersistenceMiddleware } from './middleware/padelMatchPersistence';

export const store = configureStore({
  reducer: {
    userProfile: userProfileReducer,
    games: gamesReducer,
    tournamentPlayers: tournamentPlayersReducer,
    counter: counterReducer,
    clubs: clubsReducer,
    padelMatch: padelMatchReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(padelMatchPersistenceMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
